<template>
<div>
  <div class="columns">
    <div class="column">
      <p class="has-text-grey">
        When creating a new software, a lookup to nist will be performed at creation. We will attempt to retrieve all 
        associated vulnerabilities if any for the software. All known cpes (versions) will be retrieved as well. Software vulnerability updates
        are then run every 2 hours. Nist will will tell us the last time the software vulnerability list was updated. Only if it must will our system then
        update our database.
      </p>
    </div>
  </div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input
          required
          :value="software.name"
          :error="$root.errorBag.name"
          placeholder="PHP"
          @input="updateName">Name</text-input>
      </div>
      <div class="column is-3">
        <text-input
          required
          :value="software.cpe_identifier"
          :error="$root.errorBag.cpe_identifier"
          placeholder="php:php"
          @input="updateCpeIndentifier">Software Version Identifier</text-input>
      </div>
      <div class="column is-3">
        <data-selector
          required
          no-revert
          :items="classifications"
          :value="software.cpe_classification"
          :error="$root.errorBag.cpe_classification"
          placeholder="a"
          @input="updateCpeClassification">
          Product Classification
        </data-selector>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <text-input
          required
          :value="software.version_regex"
          :error="$root.errorBag.version_regex"
          placeholder="regex"
          description="We need to parse the version number out string data."
          @input="updateVersionRegex">Version REGEX</text-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button :working="working" @submit="store">Store</submit-button>
      </div>
    </div>
  </form>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    working: false,
    classifications: [
      { value: 'a', label: 'Application' },
      { value: 'o', label: 'Operating System' },
    ]
  }),

  beforeDestroy() {
    this.clearSoftware()
  },
  
  created() {
    this.clearSoftware()
  },

  methods: {
    ...mapMutations('software', [
      'updateName',
      'clearSoftware',
      'updateCpeIndentifier',
      'updateCpeClassification',
      'updateVersionRegex'
    ]),
    store() {
      this.working = true
      this.$store.dispatch('software/store').then(() => {
        this.$toast.success('software stored')
        this.working = false
        this.$router.push({
          name: 'software'
        })
      }).catch(error => {
        this.$toast.error('try again')
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('software', [
      'software'
    ])
  }

}
</script>
